import { Injectable } from '@angular/core';
import saveAs from 'file-saver';

import {
  IBombeoArrancador,
  IBombeoCanal,
  IComando,
  IConfigCanal,
  IQueryParam,
  IUpdateBombeoArrancador,
  IUpdateBombeoCanal,
} from 'modelos/src';
import { Observable } from 'rxjs';
import { apiBase } from 'src/environments/environment';
import { HelperService } from '../../../auxiliares/helper.service';
import { HttpService } from '../../../auxiliares/http.service';

const api = apiBase;

@Injectable({
  providedIn: 'root',
})
export class BombeoService {
  constructor(private http: HttpService) {}

  // Canal
  public getCanal(id: string): Observable<IBombeoCanal> {
    return this.http.get(`${api}/bombeocanals/${id}`);
  }
  public getCanales(queryParams?: IQueryParam): Observable<{
    totalCount: number;
    datos: IBombeoCanal[];
  }> {
    const params = HelperService.getQueryParams(queryParams);
    return this.http.get(`${api}/bombeocanals`, { params });
  }
  public delCanal(id: string): Observable<IBombeoCanal> {
    return this.http.delete(`${api}/bombeocanals/${id}`);
  }
  public updateCanal(
    id: string,
    data: IUpdateBombeoCanal,
  ): Observable<IBombeoCanal> {
    return this.http.put(`${api}/bombeocanals/${id}`, data);
  }

  // Arrancador
  public getArrancador(id: string): Observable<IBombeoArrancador> {
    return this.http.get(`${api}/bombeoarrancadors/${id}`);
  }
  public getArrancadores(queryParams?: IQueryParam): Observable<{
    totalCount: number;
    datos: IBombeoArrancador[];
  }> {
    const params = HelperService.getQueryParams(queryParams);
    return this.http.get(`${api}/bombeoarrancadors`, { params });
  }
  public delArrancador(id: string): Observable<IBombeoArrancador> {
    return this.http.delete(`${api}/bombeoarrancadors/${id}`);
  }

  public updateArrancador(
    id: string,
    data: IUpdateBombeoArrancador,
  ): Observable<IBombeoArrancador> {
    return this.http.put(`${api}/bombeoarrancadors/${id}`, data);
  }

  public async exportar(
    filename: string,
    queryParams?: IQueryParam,
  ): Promise<void> {
    const params = HelperService.getQueryParams(queryParams);

    await this.http.getFile(
      `${api}/reportes/exportar/bombeo`,
      filename,
      params,
    );
  }

  // Comandos

  public getComando(id: string): Observable<IComando> {
    return this.http.get(`${api}/comandos/${id}`);
  }
  public getComandos(queryParams?: IQueryParam): Observable<{
    totalCount: number;
    datos: IComando[];
  }> {
    const params = HelperService.getQueryParams(queryParams);
    return this.http.get(`${api}/comandos`, { params });
  }
  public delComando(id: string): Observable<IComando> {
    return this.http.delete(`${api}/comandos/${id}`);
  }
  public encender(arrancador: IBombeoArrancador, velocidad?: number) {
    return this.http.post(`${api}/comandos/bombeo/encender`, {
      deveui: arrancador.deveuiCentral,
      numero: arrancador.numero,
      velocidad,
    });
  }
  public apagar(arrancador: IBombeoArrancador, velocidad?: number) {
    return this.http.post(`${api}/comandos/bombeo/apagar`, {
      deveui: arrancador.deveuiCentral,
      numero: arrancador.numero,
      velocidad,
    });
  }
  public velocidad(arrancador: IBombeoArrancador, velocidad: number) {
    return this.http.post(`${api}/comandos/bombeo/velocidad`, {
      deveui: arrancador.deveuiCentral,
      numero: arrancador.numero,
      velocidad,
    });
  }
  public frecReporte(
    canal: IBombeoCanal,
    frecuencia: number,
    tipo: 'Entrada' | 'Salida',
  ) {
    return this.http.post(`${api}/comandos/bombeo/frecReporte`, {
      deveui: canal.deveuiCentral,
      numero: canal.numero,
      frecuencia,
      tipo,
    });
  }
  public getConfigs(deveui: string) {
    return this.http.post(`${api}/comandos/bombeo/getConfigs`, { deveui });
  }
  public setConfigs(configs: IConfigCanal) {
    return this.http.post(`${api}/comandos/bombeo/setConfigs`, configs);
  }
}
